import { render } from "./pengelolaan_hbo.vue?vue&type=template&id=3057b5ba&scoped=true"
import script from "./pengelolaan_hbo.vue?vue&type=script&lang=js"
export * from "./pengelolaan_hbo.vue?vue&type=script&lang=js"

import "./pengelolaan_hbo.vue?vue&type=style&index=0&id=3057b5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3057b5ba"]])

export default __exports__